//@flow
import React, {useRef} from 'react';

import {makeStyles, TableCell, Tooltip, Typography} from '@material-ui/core';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';
import IosSwitch from '../../../../../elements/IosSwitch/IosSwitch';
import {useProductContext} from '../../../context';
import {useEditProduct} from '../../../utils/editProduct';
import {useDebounceEffect} from '../../../../../utils/react';
import {InfoOutlined} from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '.5rem',
    position: 'relative',
  },
  numberField: {
    width: '96px',
  },
  tooltipContainer: {
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    paddingRight: '.5rem',
  },
  tooltip: {
    marginLeft: theme.spacing(2),
    backgroundColor: '#F4F4F6',
    borderRadius: '8px',
    textAlign: 'center',
  },
  textTooltip: {
    textAlign: 'left!important',
    color: ' #717190',
    fontSize: '10px',
    '& span': {
      marginLeft: theme.spacing(1),
    },
  },
  infoBtn: {
    color: '#9595AB',
  },
}));

export default function ProductStockCell() {
  const classes = useStyles();

  const [product, setProduct] = useProductContext(
    product => ({
      id: product.id,
      stock: product.stockSetting && product.stockSetting.stock,
      stockEnabled: product.stockSetting && product.stockSetting.enabled,
      hasVariants:
        product.productVariantSetting?.variants &&
        product.productVariantSetting?.variants.length > 0,
    }),
    false
  );

  const firstRenderFlag = useRef(true);

  const {editProduct} = useEditProduct(product ? product.id : '');

  const hasVariants = product.hasVariants;

  const {stock, stockEnabled: enabled} = product;

  useDebounceEffect(
    () => {
      if (firstRenderFlag.current) {
        firstRenderFlag.current = false;
        return;
      }

      editProduct({
        stockSetting: {
          enabled: !!enabled,
          stock: stock || 0,
        },
      });
    },
    750,
    [enabled, stock]
  );

  const setStock = (stock: number) => {
    setProduct({
      stockSetting: {
        enabled: !!enabled,
        stock: stock || undefined,
      },
    });
  };

  const setEnabled = (enabled: boolean) => {
    setProduct({
      stockSetting: {
        enabled: !!enabled,
        stock: stock || undefined,
      },
    });
  };

  return (
    <TableCell align="right">
      <div className={classes.container}>
        <IosSwitch
          onChange={e => setEnabled(e.target.checked)}
          checked={enabled}
        />
        <CustomTextField
          name="stock"
          className={classes.numberField}
          disabled={!enabled || hasVariants}
          defaultValue={product.stock}
          type="number"
          onChange={e => {
            setStock(e.target.valueAsNumber);
          }}
        />
        {hasVariants && (
          <div className={classes.tooltipContainer}>
            <Tooltip
              placement="right"
              enterTouchDelay={0}
              classes={{tooltip: classes.tooltip}}
              title={
                <Typography className={classes.textTooltip}>
                  Debes editar el stock de cada variante
                </Typography>
              }
            >
              <InfoOutlined color="primary" className={classes.infoBtn} />
            </Tooltip>
          </div>
        )}
      </div>
    </TableCell>
  );
}
